import React from "react";

const MaritalStatus = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M17.46 34c-.545-.081-1.092-.142-1.632-.247a12.892 12.892 0 0 1-6.257-3.109c-2.063-1.846-3.516-4.098-4.143-6.82-1.212-5.272.155-9.791 4.026-13.506 1.103-1.058 2.393-1.842 3.828-2.448l1.771 2.482c-2.947 1.087-5.088 3.043-6.32 5.964C7.763 18.618 7.649 21 8.336 23.4c1.262 4.411 5.26 7.626 10 7.617 4.776-.009 8.727-3.256 9.967-7.617.776-2.726.529-5.385-.777-7.9-1.299-2.502-3.305-4.193-5.943-5.143l1.77-2.483c.93.373 1.786.853 2.586 1.43 2.447 1.767 4.198 4.089 5.071 7.012 1.326 4.434.655 8.582-2.086 12.297-2.164 2.934-5.088 4.665-8.656 5.242-.362.058-.727.096-1.09.144H17.46Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M12.107 4.49c.634-.793 1.267-1.594 1.91-2.387.053-.065.177-.1.266-.1 2.689-.004 5.377-.005 8.066.003.11 0 .254.076.326.164.582.712 1.145 1.44 1.727 2.15.129.157.103.251-.001.398-1.54 2.153-3.076 4.308-4.608 6.466-.107.151-.212.21-.4.205-.725-.014-1.449.001-2.173-.011-.111-.002-.265-.06-.326-.146-1.586-2.209-3.162-4.425-4.74-6.64-.017-.022-.025-.052-.047-.101Z"
            fill={fill}
        />
    </svg>
);

export default MaritalStatus;